<ion-header mode="ios">
  <ion-toolbar mode="ios">
    <app-text
      [textSize]="TextSizes.h1Header"
      [textType]="TextType.base"
      [text]="'ФОТООТЧЁТ'"
    ></app-text>

    <ion-buttons slot="end">
      <ion-icon
        (click)="closeAlert()"
        slot="icon-only"
        class="close-photo-report-icon"
        src="assets/images/icons-svg/close.svg"
      ></ion-icon>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [forceOverscroll]="false" [forceOverscroll]="false">
  <div class="create-photo-report">
    @if (categories.length) {
      <form class="create-photo-report__form" [formGroup]="createPhotoReportForm">
        <div class="create-photo-report__form-comment">
          <ion-grid>
            <ion-row>
              <ion-col size="col-comment"
                ><div class="create-photo-report__form-comment-icon">
                  <app-image [img]="'assets/images/icons-svg/comment.svg'"></app-image></div
              ></ion-col>
              <ion-col>
                <ion-item class="create-photo-report__form-comment-textarea">
                  <ion-textarea
                    formControlName="description"
                    rows="1"
                    placeholder="Комментарий"
                    [autoGrow]="true"
                    maxlength="255"
                    [disabled]="isLoading"
                  ></ion-textarea> </ion-item
              ></ion-col>
            </ion-row>
          </ion-grid>
        </div>
        <div class="create-photo-report__categories">
          @for (category of categories; track trackByFn($index)) {
            <div class="wrapper">
              @if (currentPlatform$ | async; as currentPlatform) {
                <div class="create-photo-report__categories-item">
                  <app-text
                    [textSize]="TextSizes.h1Header"
                    [textType]="TextType.base"
                    [text]="
                      category.categoryValue
                        ? category.categoryValue.toUpperCase()
                        : 'БЕЗ КАТЕГОРИИ'
                    "
                  ></app-text>
                  <input
                    #imageInput
                    type="file"
                    [accept]="availableImageFormats"
                    (change)="handleUploadImages($event, category.categoryName)"
                    multiple
                    [style.display]="'none'"
                  />
                  <input
                    #cameraInput
                    type="file"
                    accept="image/*"
                    capture="environment"
                    (change)="handleUploadImages($event, category.categoryName)"
                    [style.display]="'none'"
                  />
                  <div
                    class="create-photo-report__categories-item-add"
                    [class.disabled]="isLoading"
                    (click)="openImageSource(category.categoryName)"
                  >
                    <app-image [img]="'assets/images/icons-svg/add-post-icon.svg'"></app-image>
                  </div>
                </div>
                @if (uploadingImages$ | async; as uploadingImages) {
                  <div class="create-photo-report__categories-images-wrapper">
                    <div
                      [id]="category.categoryName"
                      class="create-photo-report__categories-images"
                    >
                      @for (
                        image of uploadingImages[category.categoryName];
                        track trackByFn($index)
                      ) {
                        @if (!image.error) {
                          <app-photo-report-image-item
                            [image]="image"
                            [categoryName]="category.categoryName"
                            [isLoading]="isLoading"
                            (rotate)="changeImageRotate($event.image, $event.categoryName)"
                            (delete)="
                              handleDeleteChosenItem($event.localId, $event.id, $event.categoryName)
                            "
                            (loaded)="handleImageLoaded($event)"
                          ></app-photo-report-image-item>
                        }
                      }
                    </div>
                    @if (
                      uploadingImages[category.categoryName] &&
                      uploadingImages[category.categoryName].length > 3
                    ) {
                      @if (category.showLeftArrow) {
                        <div class="arrow arrow-left" (click)="scrollLeft(category.categoryName)">
                          <img src="assets/images/icons-svg/arrow-right-big.svg" />
                        </div>
                      }
                      @if (category.showRightArrow) {
                        <div class="arrow arrow-right" (click)="scrollRight(category.categoryName)">
                          <img src="assets/images/icons-svg/arrow-right-big.svg" />
                        </div>
                      }
                    }
                  </div>
                }
              }
            </div>
          }
        </div>
      </form>
    }
  </div>
</ion-content>

<ion-footer>
  <app-button
    [btnType]="Buttons.small"
    text="готово"
    textSize="text-1"
    [isDisabled]="!areAllImagesLoaded()"
    (click)="createAlert()"
  ></app-button>
</ion-footer>
